import { Modal } from 'uiKit/organisms/Modal';
import { Header, Footer, Content } from 'uiKit/organisms/Modal';
import { Button } from 'uiKit/atoms/Button/Button';
import styles from './DocumentModal.module.scss';

type DocumentModalProps = {
  open: boolean;
  title: string;
  closeHandler: () => void;
  agreeHandler: () => void;
  children: React.ReactNode;
};

const DocumentModal = ({ open, title, closeHandler, agreeHandler, children }: DocumentModalProps) => {
  return (
    <Modal open={open} onClose={closeHandler} wrapperClassName={styles.bns3_document_modal_wrapper}>
      <Header title={title} />
      <Content>{children}</Content>
      <Footer>
        <Button variant="contained" color="primary" onClick={agreeHandler}>
          Agree
        </Button>
      </Footer>
    </Modal>
  );
};

export default DocumentModal;
